// extracted by mini-css-extract-plugin
export var link = "_v6-0";